import type { MeSubscription } from "@/lib/api/hooks";

/** Supply variants share purchase ownership even when the experiment is off
 * and the catalog no longer includes its dose_offers list. Not an Rx matcher. */
export function subscriptionPurchaseIdentity(productId: string): string {
  return productId === "nad-injection-200mg-2x5ml"
    ? "nad-injection-200mg-5ml"
    : productId;
}

/**
 * Whether this subscription should make its product count as "IN YOUR PLAN".
 *
 * The backend resolves this from Stripe's real lifecycle state. The fallback
 * keeps the portal compatible while backend and frontend deploy separately.
 */
export function subscriptionBlocksRepurchase(
  subscription: MeSubscription,
): boolean {
  if (typeof subscription.blocks_repurchase === "boolean") {
    return subscription.blocks_repurchase;
  }
  return subscription.status !== "cancelled";
}
